import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@material-tailwind/react";
import ReduxProvider from "./redux/store";
import { Toaster } from "react-hot-toast";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
// import ReactGA from "react-ga4";

const theme = {
	select: {
		styles: {
			base: {
				container: {
					minWidth: "min-w-[100px]",
				},
			},
		},
	},
	menu: {
		styles: {
			base: {
				item: {
					
					disabled: {
						opacity: "opacity-100",
						cursor: "cursor-not-allowed",
						pointerEvents: "pointer-events-none",
						userSelect: "select-none",
						bg: "hover:bg-transparent focus:bg-transparent active:bg-transparent",
						color: "hover:text-blue-gray-500 focus:text-blue-gray-500 active:text-blue-gray-500",
					},
				},
			},
		},
	},
};

// ReactGA.initialize("G-8JRS58F59B");
// ReactGA.send({ hitType: "pageview", page: window.location.pathname });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<>
		<ReduxProvider>
			<ThemeProvider value={theme}>
				<Toaster />
				<App />
			</ThemeProvider>
		</ReduxProvider>
	</>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
